import React from "react";
import { Sparkles } from "lucide-react";

interface ManualHandleInputProps {
  value: string;
  onChange: (val: string) => void;
  error?: string;
}

export const ManualHandleInput: React.FC<ManualHandleInputProps> = ({
  value,
  onChange,
  error,
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-[16px] font-semibold text-slate-800">
        Add handles manually
      </label>
      <p className="text-[14px] text-slate-500 leading-normal">
        Enter Instagram handles or profile links, one per line or separated by commas
      </p>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={`@cristiano, @virat.kohli\nhttps://www.instagram.com/shreyaghoshal/`}
        className="w-full min-h-[120px] rounded-[10px] border border-slate-200 p-3.5 text-slate-800 text-sm placeholder-slate-400 focus:outline-none focus:border-[#A655F8] focus:ring-0 transition-colors"
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}

      <div className="flex items-center gap-1.5 text-[14px]">
        <Sparkles className="w-5 h-5 shrink-0 text-[#A655F8]" />
        <span>We'll fetch profile data, audience stats, and more.</span>
      </div>
    </div>
  );
};
